<template>
  <bk-page class="bk-shopSearch" pageType="navPage" :navBarInfo="navBarInfo">

		<template v-slot:slot-rightItems>
			<bk-view class="view-search-main">
				<bk-input v-model:value="formData.keyword" langCode_placeholder="bkShopSearch_placeholder" autofocus @pressEnter="handleSearch" />
				
				<bk-view  class="view-search-right" v-if="showPage">
					<bk-view v-if="showPage==='shopList'" @click="handlePosition">
						<bk-icon icon="icon-fi-rr-marker"></bk-icon>
					</bk-view>

					<bk-view class="view-shopLocation-search" v-if="showPage==='shopLocation'" @click="handleSearch" >
						<bk-icon icon="icon-search"/>
						<bk-lang code="bkShopSearch_search"></bk-lang>
					</bk-view>
				</bk-view>
			</bk-view>
		</template>
	
		<bk-veiw class="view-container">

			<shopList v-if="showPage==='shopList'" ref="shopList" :locInfo="locInfo" :keyword="formData.keyword" @handleItemClick="handleShopItemClick" />

			<shopLocation v-if="showPage==='shopLocation'"  :locInfo="locInfo" :curRows="curItem"  />

			<bk-view class="view-fast-main" v-else>
				<bk-view class="view-fast-item" v-if="recentList.length">
					<bk-view class="view-header">
						<bk-title langCode="bkShopSearch_recent"></bk-title>
						<bk-view @click="handleDelRecentKeywords"><bk-icon icon="icon-dusbin"></bk-icon></bk-view>
					</bk-view>
					<bk-view class="view-tag-list">
						<bk-view v-for="(item,index) in recentList" :key="item.id">
							<bk-view v-if="expand ? expand: index <= 3" class="view-tag-item" @click="handleKeywordClick(item)">{{ item.keyword }}</bk-view>
						</bk-view>
						<bk-view class="view-tag-item view-icon-main" v-if="!expand" @click="expand=true">
							<bk-icon icon="icon-youjiantou"></bk-icon>
						</bk-view>
					</bk-view>
				</bk-view>
				<bk-view class="view-fast-item" v-if="recommendationList.length">
					<bk-view class="view-header">
						<bk-title langCode="bkShopSearch_recommendation"></bk-title>
					</bk-view>
					<bk-view class="view-tag-list">
						<bk-view class="view-tag-item" v-for="item in recommendationList" :key="item.id" @click="handleKeywordClick(item)">{{ item.keyword }}</bk-view>
					</bk-view>
				</bk-view>
			</bk-view>
			
		</bk-veiw>

		
	</bk-page>
</template>

<script>
	import { authReq } from '@/reqService';
	import shopList from './shopList/shopList.vue';
	import shopLocation from './shopLocation/shopLocation.vue';

	export default {
		name: 'bk-shopSearch',
		components:{ shopList, shopLocation},
		data (){
			return {
				navBarInfo: {
					backFlag: true,
				},
				formData:{},
				showPage:'',
				curItem:null,
				recommendationList:[],
				recentList:[],
				userInfo:this.$bk_getUserInfo(),
				locInfo:null,
				expand:false,
			};
		},
		created (){
			this.getCurrentPosition();
		},
		mounted (){
			this.initData();
		},
		methods:{
			initData (){

				if(this.userInfo?.userId){
					this.requestGetUserKeywordList();
				}
				this.requestGetKeywordList();
			},
			async requestGetKeywordList (){
				const res= await authReq.requestGetKeywordList(this);
				this.recommendationList = res;
			},
			async requestGetUserKeywordList (){
				const res= await authReq.requestGetUserKeywordList(this, {userId:this.userInfo.userId });
				this.recentList = res;
			},
			setShowPage (showPage = '') {
				this.showPage = showPage;
			},
			handleSearch (){
				const { keyword } = this.formData;
				
				if(keyword){
					if(this.showPage==='shopList'){
						this.$refs.shopList.reloadData();
					}else {
						this.setShowPage('shopList');
					}
				}else {
					this.curItem = '';
					this.setShowPage('');
				}
			},
			handleKeywordClick (item){
				this.formData.keyword = item.keyword;

				this.handleSearch();
			},
			handleSelectShop ({ key, row}){
				if(key ==='location'){
					this.setShowPage('shopLocation');
				}
				this.curItem = row;
			},
			handleShopItemClick ({row, key}){
        
				if(key ==='position'){
					this.getCurrentPosition();
					return false;
				}
				if (typeof window.showReserve == 'function') {

					if(key==='shopItem'){
						window.showReserve({
							resShopInfo:{ ...row, id:row.compId },
							resItemInfo: undefined,
						});
					}

					if(key==='reserve'){
						window.showReserve({
							resShopInfo:{ ...row, id:row.compId },
							resItemInfo: { ...row, projectId:row.id },
						});
					}
					
				}
			},
			handlePosition (){
				this.getCurrentPosition(() => {
					this.setShowPage('shopLocation');
				});
			},
			getCurrentPosition (successCallback){
				window.getCurrentPosition({
					callback: (e) => {
						console.log('定位结果：', e);

						if (e.success) {
							this.locInfo = e.locInfo || {
								lat: 31.134726,
								lng: 121.364039,
							};

						} else {
							this.locInfo = {
								lat: 31.134726,
								lng: 121.364039,
							};
						}

						successCallback && successCallback();
            
					}
				});
			},
			async handleDelRecentKeywords (){
				await authReq.requestDeleteUserRecentKeywords(this, {userId: this.userInfo?.id });

				this.initData();
			}
		}
		
	};
</script>

<style lang="less">
@import './bk-shopSearch.less';
</style>